import React from "react";

const DeleteModal = ({
  isOpen,
  onClose,
  title,
  itemName,
  partNumber,
  type,
  revision,
  isLoading,
  onConfirm,
  comment,
  setComment,
  isConfirmModal = false,
}) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content_addsection">
        {/* Header */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            borderBottom: "1px solid #e0e0e0",
          }}
        >
          <h4
            style={{
              marginLeft: "23px",
              fontSize: "18px",
              color: "#333333",
            }}
          >
            {isConfirmModal ? (
              <>
                <span style={{ color: "#ff0066" }}>Delete</span> {itemName} of{" "}
                {type} {partNumber}
              </>
            ) : (
              <>Confirm Delete {itemName} of {partNumber}</>
            )}
          </h4>
          <button
            onClick={onClose}
            style={{
              position: "absolute",
              right: "10px",
              top: "10px",
              background: "none",
              border: "none",
              fontSize: "20px",
              cursor: "pointer",
              color: "#666",
            }}
            disabled={isLoading}
          >
            ✕
          </button>
        </div>

        {/* Modal Body */}
        <div
          style={{ padding: "24px", marginTop: "-28px", color: "#333333" }}
        >
          {isConfirmModal ? (
            <h4 style={{ fontSize: "14px", fontWeight: "normal" }}>
              Are you sure, you want to delete the {itemName}?
            </h4>
          ) : (
            <>
              <h4 style={{ fontSize: "14px" }}>
                For {type} {partNumber} - Rev {revision}
              </h4>

              <p style={{ fontSize: "14px", color: "#333333" }}>
                <strong>Editor:</strong>{" "}
                <span style={{ marginLeft: "10px" }}>
                  {localStorage.getItem("user_name")}
                </span>
              </p>

              <label
                className="modal-label"
                style={{ fontSize: "14px", color: "#333333" }}
              >
                Comment
                <span className="required" style={{ marginLeft: "-1px" }}>
                  *
                </span>
              </label>
              <textarea
                className="modal-textarea"
                placeholder="Enter your comments here..."
                value={comment}
                onChange={(e) => setComment(e.target.value)}
                style={{
                  width: "100%",
                  minHeight: "100px",
                  padding: "8px",
                  border: "1px solid #ddd",
                  borderRadius: "4px",
                }}
                disabled={isLoading}
              />
            </>
          )}
        </div>

        {/* Footer */}
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: "10px",
            padding: "16px 24px",
            borderTop: "1px solid #e0e0e0",
            marginTop: "-10px",
            position: "relative",
          }}
        >
          {isLoading && (
            <div
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "rgba(255, 255, 255, 0.7)",
                zIndex: 10,
              }}
            >
              <div
                className="loader-spinner"
                style={{
                  border: "4px solid #f3f3f3",
                  borderRadius: "50%",
                  width: "20px",
                  height: "20px",
                  animation: "spin 1s linear infinite",
                  marginRight: "10px",
                }}
              />
              <span>Processing...</span>
            </div>
          )}
          <button
            onClick={onClose}
            style={{
              padding: "8px 16px",
              border: "1px solid #ccc",
              borderRadius: "4px",
              background: "#6c757d",
              color: "#e9ecef",
              cursor: isLoading ? "not-allowed" : "pointer",
            }}
            disabled={isLoading}
          >
            Close
          </button>
          <button
            onClick={onConfirm}
            style={{
              padding: "8px 16px",
              border: isConfirmModal ? "1px solid #DC3545" : "1px solid #007bff",
              borderRadius: "4px",
              background: isConfirmModal ? "#dc3545" : "#007bff",
              color: "white",
              cursor: isLoading ? "not-allowed" : "pointer",
              opacity: isLoading ? 0.7 : 1,
            }}
            disabled={isLoading}
          >
            {isLoading ? "Processing..." : isConfirmModal ? "Delete" : "Save"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteModal;
